module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_id_card_m.0ffd438e1192e5500b8be56961d347a4.png";